import { useDispatch } from 'react-redux';

import {
  createMetalStreamAmount,
  updateMetalStreamAmount,
} from '../store/actions/metalStream/metalStreamActions';
import { metalStreamDataHelper } from '../util/helpers/metalStreamDataHelper';
import useApplicationUid from './useApplicationUid';
import { useMetalStreamData } from './useMetalStreamData';

const useMetalStreamAmountDispatch = () => {
  const dispatch = useDispatch();
  const { MetalStreamData } = useMetalStreamData();

  const { ApplicationUid } = useApplicationUid();

  const metalStreamAmountDispatch = ({ data, onSuccess, onError }) => {
    const Amount = metalStreamDataHelper(MetalStreamData, 'Amount');

    const shouldSkip = Amount === data?.Amount;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    if (Amount) {
      dispatch(
        updateMetalStreamAmount({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        createMetalStreamAmount({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { metalStreamAmountDispatch };
};

export default useMetalStreamAmountDispatch;
